var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAreaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_1223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8434 17.4063H6.1488C5.29567 17.4063 4.59766 16.7083 4.59766 15.8551V6.16052C4.59766 5.30739 5.29567 4.60938 6.1488 4.60938H15.8434C16.6966 4.60938 17.3946 5.30739 17.3946 6.16052V15.8551C17.3946 16.7083 16.6966 17.4063 15.8434 17.4063Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8434 17.4063H6.1488C5.29567 17.4063 4.59766 16.7083 4.59766 15.8551V6.16052C4.59766 5.30739 5.29567 4.60938 6.1488 4.60938H15.8434C16.6966 4.60938 17.3946 5.30739 17.3946 6.16052V15.8551C17.3946 16.7083 16.6966 17.4063 15.8434 17.4063Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 6.41667C5.59585 6.41667 6.41667 5.59585 6.41667 4.58333C6.41667 3.57081 5.59585 2.75 4.58333 2.75C3.57081 2.75 2.75 3.57081 2.75 4.58333C2.75 5.59585 3.57081 6.41667 4.58333 6.41667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4163 6.41667C18.4289 6.41667 19.2497 5.59585 19.2497 4.58333C19.2497 3.57081 18.4289 2.75 17.4163 2.75C16.4038 2.75 15.583 3.57081 15.583 4.58333C15.583 5.59585 16.4038 6.41667 17.4163 6.41667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 19.2502C5.59585 19.2502 6.41667 18.4294 6.41667 17.4168C6.41667 16.4043 5.59585 15.5835 4.58333 15.5835C3.57081 15.5835 2.75 16.4043 2.75 17.4168C2.75 18.4294 3.57081 19.2502 4.58333 19.2502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4163 19.2502C18.4289 19.2502 19.2497 18.4294 19.2497 17.4168C19.2497 16.4043 18.4289 15.5835 17.4163 15.5835C16.4038 15.5835 15.583 16.4043 15.583 17.4168C15.583 18.4294 16.4038 19.2502 17.4163 19.2502Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_1223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaWhite);
export default __webpack_public_path__ + "static/media/area-white.a4dc9a87dfa365bfaef141e77aa99972.svg";
export { ForwardRef as ReactComponent };